import { onScopeDispose } from 'vue'

/** Holds the given live feeds for as long as the calling component or scope is alive; the one way a view gets live data. */
export function useRetained(...retains: ReadonlyArray<() => () => void>): void {
  const releases = retains.map((retain) => retain())
  onScopeDispose(() => {
    for (const release of releases) release()
  })
}
